import {gql} from '@apollo/client';
import { DELIVERY_TASK_ORDER_FIELDS, DeliveryTaskOrderType } from '../graphql/types/DeliveryTaskOrderType';

export const GET_DELIVERY_TASK_ORDER_LIST_FOR_DELIVERED = gql`
  query DeliveryQuery($maxDeliveryTaskId: Long!, $startTimestamp: Long, $endTimestamp: Long) {
    getDeliveryTaskOrderListForDelivered(maxDeliveryTaskId: $maxDeliveryTaskId, startTimestamp: $startTimestamp, endTimestamp: $endTimestamp) {
      maxDeliveryTaskId
      sameAddressDiscountParcelCount
      deliveryTaskOrderList {
        ...DeliveryTaskOrderFields
      }
      podAbnormalOrderList{
          id
          orderId
          routeName
          stopNumber
          trackingNumber
          updatedAt
          deliveredDriverAccountName
          orderWithAddress {
              deliveryAddress {
                  addressLine1
                  addressLine2
                  city
                  company
                  countryCode
                  email
                  extension
                  fullName
                  id
                  instructions
                  phoneNumber
                  state
                  zipcode
              }
              order {
                  deliverAt
                  deliveredAt
                  deliveryAttempts
                  isDelivered
                  isFinished
                  orderTime
                  id
                  trackingNumber
                  podReviewStatus
                  podReviewMessage {
                    id
                    failureOtherReason
                    lang
                    translateFailureOtherReason {
                      lang
                      translateFailureOtherReason
                    }
                  }
                  podImageS3KeysJson
                  podImageS3UrlsJson
                  podHasBeenManualDisapproved
                  isModifiedPodPhotos
              }
          }
      }
    }
  }
  ${DELIVERY_TASK_ORDER_FIELDS} 
`;

export interface DeliveryTaskOrderListForDeliveredResponse {
    getDeliveryTaskOrderListForDelivered: {
        maxDeliveryTaskId: number;
        sameAddressDiscountParcelCount: number;
        deliveryTaskOrderList: DeliveryTaskOrderType[];
        podAbnormalOrderList: DeliveryTaskOrderType[];
    }
}
